import { render, staticRenderFns } from "./DirFilesTableReportDialog.vue?vue&type=template&id=2b7bbd12&scoped=true&"
import script from "./DirFilesTableReportDialog.vue?vue&type=script&lang=js&"
export * from "./DirFilesTableReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./DirFilesTableReportDialog.css?vue&type=style&index=0&id=2b7bbd12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7bbd12",
  null
  
)

export default component.exports